// extracted by mini-css-extract-plugin
module.exports = {"footerButton":"_1-cPw"};